import { Injectable } from '@angular/core';
import { observable, action } from 'mobx-angular';
import { AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { DataService } from 'src/app/services/data.service';
import { APPS } from 'src/app/dummy/app';
import { pushToObject } from 'src/app/services/mapping.service';

@Injectable({
    providedIn: 'root'
})
export class LazyData {
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable data: Array<any> = [];
    @observable empty: boolean = false;
    @observable done: boolean = false;
    @observable fetching: boolean = false;
    @observable lastVisible: any = null;


    subscribe: any = null;
    constructor(private ds: DataService) { }

   

    @action
    dispost() {
        this.data = [];
        if (this.subscribe) this.subscribe.unsubscribe()
    }

    @action
    fetchData(ref: AngularFirestoreCollection) {
        this.loading = true;
        this.data = null;
        this.subscribe = ref.valueChanges().subscribe(docs => {
            this.data = docs;
            if (docs.length > 0 && docs.length >= APPS.SIZE) {
                this.lastVisible = docs[docs.length - 1];
            } else {
                this.lastVisible = null;
                this.done = true;
            }
            this.loading = false;
            this.empty = docs.length === 0;
        })
    }

    @action
    fetchMore(ref: AngularFirestoreCollection) {
        if (this.fetching || this.done || this.lastVisible === null) { return; }
        this.fetching = true;
        setTimeout(() => {
            ref.valueChanges()
                .subscribe(docs => {
                    if (docs.length > 0 && docs.length >= APPS.SIZE) {
                        this.lastVisible = docs[docs.length - 1];
                    } else {
                        this.done = true;
                        this.lastVisible = null;
                    }
                    this.data = this.data.slice().concat(docs);
                    this.fetching = false;
                });
        }, 300);

    }


    @action
    save(ref: AngularFirestoreCollection, item: any, callback) {
        this.process = true;
        ref.doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

}
